import { Vue, Router, DivisionMarkerLayout } from "division-marker";

import { Routes as SbRoutes, RouteConfig } from "saiten-base";
import { Routes as DmRoutes } from "division-marker";

import WtDmLayout from "@/components/WtDmLayout.vue";

import Index from "@/Index.vue";

// 生徒 =====================================
import StudentSignUp from "@/students/SignUp.vue";
import StudentTop from "@/students/Top.vue";
import StudentSignIn from "@/students/SignIn.vue";
import StudentAnswerImage from "@/students/AnswerImage.vue";
import StudentQR from "@/students/QR.vue";
import StudentPhotoTaken from "@/students/PhotoTaken.vue";
import StudentPasswordChange from "@/students/PasswordChange.vue";

// 教師
import AppStudents from "@/AppStudents.vue";
import Results from "@/branches/Results.vue";
import DmProgress from "@/components/Progress.vue";
import QuestionAnswers from "@/components/QuestionAnswers.vue";
// import BranchSignIn from '@/branches/BranchSignIn.vue';
// import StudentBranchResults from '@/branches/Results.vue';

// 管理者 ===========================
import Staffs from "@/saiten/Staffs.vue";
import SaitenFuriwakes from "./components/SaitenFuriwakes.vue";
import DjBranches from "./components/DjBranches.vue";
import DjStudents from "./components/DjStudents.vue";
import QRegistrationEmail from "./components/QRegistrationEmail.vue";

Vue.use(Router);

// const routes: {path: string} = [{ path: '/sign_in', component: SignIn }]
export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      // 生徒画面
      path: "/",
      component: AppStudents,
      children: [
        { path: "/sign_up", component: StudentSignUp },
        { path: "/", component: Index },
        { path: "/sign_in", component: StudentSignIn },
        { path: "/study/top", component: StudentTop },
        {
          path: "/study/answer_image/:sheet_activity_id",
          component: StudentAnswerImage,
          props: true
        },
        { path: "/study/qr", component: StudentQR },
        {
          path: "/study/take/:sheet_id/:sheet_activity_id",
          name: "PhotoTakenView",
          component: StudentPhotoTaken,
          props: true
        },
        { path: "/study/password_change", component: StudentPasswordChange }

        // {path: '/admin/sign_in', component: BranchSignIn},
        // {path: '/branch/results', component: StudentBranchResults},
      ]
    },
    {
      path: "/dm",
      component: WtDmLayout,
      children: DmRoutes.concat(SbRoutes).concat([
        { path: "progress", component: DmProgress },
        { path: "staffs", component: Staffs },
        { path: "saiten_furiwakes", component: SaitenFuriwakes },
        { path: "branch_results", component: Results },
        { path: "question_answers", component: QuestionAnswers },
        { path: "dj_branches", component: DjBranches },
        { path: "dj_students", component: DjStudents },
        { path: "q_registration_email", component: QRegistrationEmail }
      ])
    }
    // { path: '/dm', component: AppDm, children: DmRoutes.concat(DmjRoutes) },
  ]
});
